import React from "react";

const AboutUs = () => {
	return (
		<div className="section">
			<h4>ABOUT US</h4>
			<p className="para-large">A consultancy that transforms businesses to compete for tomorrow</p>
			<p>
				Enact is a management consulting firm with combined experience of over 18 years. We believe in providing
				solutions and practical capabilities that guarantee sustainable business value to our clients. We are dedicated
				towards helping organizations realize their purpose and objectives, especially in an ever changing world, we
				walk with our clients and provide support to become agile and create long-term value for tomorrow.
			</p>
		</div>
	);
};

export default AboutUs;
